import React, { CSSProperties } from 'react';
import * as Styled from './styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface DropdownContentProps {
	firstItem?: boolean;
	imageIcon: any;
	contentText: string;
	contentLink: string;
	testId: string;
	openInNewTab?: boolean;
}

const DropdownContent: React.FunctionComponent<DropdownContentProps> = ({
	firstItem,
	imageIcon,
	contentText,
	contentLink,
	testId,
	openInNewTab,
}) => {
	const defaultImageStyle: CSSProperties = {
		color: 'inherit',
		height: '20px',
		width: '20px',
	};

	return (
		<Styled.DropdownContentItem data-id={testId}>
			<Styled.DropdownContentLink
				data-id={`${testId}_link`}
				href={contentLink}
				target={openInNewTab ? '_blank' : undefined}
			>
				{firstItem ? <Styled.DropdownContentItemPointer /> : null}
				<FontAwesomeIcon icon={imageIcon} style={defaultImageStyle} />
				<Styled.DropdownContentText>{contentText}</Styled.DropdownContentText>
			</Styled.DropdownContentLink>
		</Styled.DropdownContentItem>
	);
};

export default DropdownContent;
